import React, { Fragment } from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom"; // HashRouter kullanıyoruz

import Homepage from "./homepage/index";
import About from "./homepage/About";
import Service from "./homepage/Service";
import Project from "./homepage/Project";
import News from "./homepage/News";
import DetailService from "./homepage/DetailService";
import DetailProject from "./homepage/DetailProject";
import DetailNews from "./homepage/DetailNews";
import Contact from "./homepage/Contact";
import Terms from "./homepage/Terms";
import Privacy from "./homepage/Privacy";

const Index = (props) => {
  return (
    <Fragment>
      <Router>
        <Switch>
          <Route exact path="/">
            <Homepage />
          </Route>
          <Route exact path="/hakkimizda">
            <About />
          </Route>
          <Route exact path="/servislerimiz">
            <Service />
          </Route>
          <Route exact path="/project">
            <Project />
          </Route>
          <Route exact path="/news">
            <News />
          </Route>
          <Route exact path="/iletisim">
            <Contact />
          </Route>
          <Route exact path="/servislerimiz/detay/:id">
            <DetailService />
          </Route>
          <Route exact path="/project/detay">
            <DetailProject />
          </Route>
          <Route exact path="/news/detay">
            <DetailNews />
          </Route>
          <Route exact path="/referanslarimiz">
            <Terms />
          </Route>
          <Route exact path="/privacy">
            <Privacy />
          </Route>
        </Switch>
      </Router>
    </Fragment>
  );
};

export default Index;
